import React, { useState, useEffect, useRef } from 'react';
import Filter from '../../components/filter/filter';
import { api } from '../../components/api/api';
import { format } from 'date-fns';
import ArquivoPedidoTable from './ArquivoPedidoTable';
import ArquivoPedidoModal from './ArquivoPedidoModal';
import { Alert, AlertErro } from '../../util/Alertas';

function ArquivoPedido() {
    const [pedidos, setPedidos] = useState([]);
    const refModal = useRef();
    const [pedidosFiltro, setPedidoFiltro] = useState([]);
    const [statusPagamento, setStatusPagamento] = useState([]);
    const [statusPedido, setStatusPedido] = useState([]);
    const [dtInicio, setDtInicio] = useState('');
    const [dtFim, setDtFim] = useState('');
    const [produtos, setProdutos] = useState([]);
    const [nome, setNome] = useState('');
    const [nPedido, setNPedido] = useState('');
    const [vendedores, setVendedores] = useState([]);
    const [vendedorSelecionado, setVendedorSelecionado] = useState(null);
    const [statusPagamentos, setStatusPagamentos] = useState([
        { status_pagamento_id: 1, nome: 'Parcial' },
        { status_pagamento_id: 2, nome: 'Pagamento Concluído' },
        { status_pagamento_id: 3, nome: 'Pagamento Pendente' }
    ]);
    const [statusPagamentosSelecionado, setStatusPagamentosSelecionado] = useState(null);

    const BuscarTodosPedidos = () => {
        api.get(`api/Pedidos/BuscarTodos?q=${nome}&dtInicio=${dtInicio}&dtFim=${dtFim}&nPedido=${nPedido.replaceAll("_", "")}&vendedor=${vendedorSelecionado}&stautsPagamento=${statusPagamentosSelecionado}`, res => {
            setStatusPagamento(res.data.statusPagamento);
            setStatusPedido(res.data.statusPedido);
            setPedidos(res.data.pedidos);
            setPedidoFiltro(res.data.pedidos.filter(x => x.status_pedido_id !== 5 && x.status_pedido_id !== 4));
        }, erro => {
            AlertErro(erro);
        })
    }

    const BuscarTodosVendedores = () => {
        api.get("/Usuario/Vendedores", res => {
            setVendedores(res.data);
        }, erro => {
            AlertErro(erro)
        })
    }

    const BuscarTodosProdutos = () => {
        api.get("/api/Produto/BuscarTodos", res => {
            setProdutos(res.data);
        }, erro => {
            AlertErro(erro)
        })
    }

    useEffect(() => { BuscarTodosPedidos(); BuscarTodosProdutos(); BuscarTodosVendedores(); }, []);

    const onChangeFiltroStatusPedido = e => {
        const value = e.target.value;
        if (value == "0" || value == 0) {
            setPedidoFiltro(pedidos);
        } else if (value == "-1" || value == -1) {
            setPedidoFiltro(pedidos.filter(x => x.status_pedido_id !== 5 && x.status_pedido_id !== 4));
        } else {
            setPedidoFiltro(pedidos.filter(x => x.status_pedido_id === parseInt(value)))
        }
    }


    return (
        <div className="content">
            <ArquivoPedidoModal
                ref={refModal}
                funcaoExcluir={true}
            />
            <Filter
                fetchClientes={BuscarTodosPedidos}
                setDataInicio={setDtInicio}
                setDataFim={setDtFim}
                dataInicio={dtInicio}
                dataFim={dtFim}
                showNovoCliente={false}
                showFiltroNome={true}
                filtroNome={nome}
                filtroStatusPedido={true}
                statusPedido={statusPedido}
                onChangeFiltroStatusPedido={onChangeFiltroStatusPedido}
                handleInputChange={e => { setNome(e.target.value); BuscarTodosPedidos() }}
                extrairDados={false}
                nPedido={nPedido}
                setNPedido={setNPedido}
                showNPedido={true}
                vededores={vendedores}
                filtroVendedor={vendedores.length > 0}
                setVendedorSelecionado={setVendedorSelecionado}
                vendedorSelecionado={vendedorSelecionado}
                statusPagamentos={statusPagamentos}
                setStatusPagamentos={setStatusPagamentos}
                statusPagamentosSelecionado={statusPagamentosSelecionado}
                setStatusPagamentosSelecionado={setStatusPagamentosSelecionado}
                filtroStatusPagamento={true}
            />
            <ArquivoPedidoTable
                refModal={refModal}
                pedidos={pedidos}
                statusPagamento={statusPagamentos}
                statusPedido={statusPedido}
            />
        </div>
    );
}

export default ArquivoPedido;